import { createSlice } from "@reduxjs/toolkit";

export const paymentModeAndFeesSlice = createSlice({
	name: "paymentModeAndFees",
	initialState: {
		initialData: [],
		partnerList: [],
		paymentModeList: [],
		addedData: [],
		editedData: [],
		onEditCellList: [],
	},
	reducers: {
		getInitialData: (state, actions) => {
			state.initialData = actions.payload;
		},
		getPartnerList: (state, actions) => {
			state.partnerList = actions.payload;
		},
		getPaymentModeList: (state, actions) => {
			state.paymentModeList = actions.payload;
		},

		// handleOnEditPaymentModeReducer: (state, actions) => {
		// 	let tempInitialData = [...state.initialData];
		// 	const { rowId, newValue, field } = actions.payload;
		// 	console.log({ reducerreceived: rowId, newValue, field });
		// 	console.log({ reducerData: tempInitialData[rowId][field], newValue });
		// 	tempInitialData[rowId][field] = newValue;
		// 	state.initialData = tempInitialData;
		// },

		handleOnEditPaymentModeReducer: (state, actions) => {
			let tempInitialData = [...state.initialData]; // Create a copy of initial data to ensure immutability
			const { rowId, newValue, field } = actions.payload; // Destructure the payload

			// Debugging log to check the values of rowId, newValue, and field
			console.log({ reducerreceived: rowId, newValue, field });

			// Check if the rowId is valid (not -1 or out of bounds)
			if (rowId >= 0 && rowId < tempInitialData.length) {
				// Update the value at the specified rowId and field
				console.log({
					reducerData: tempInitialData[rowId][field],
					newValue,
				});
				tempInitialData[rowId][field] = newValue;
			} else {
				// If rowId is invalid, log a warning (you can handle the error more gracefully as needed)
				console.warn("Invalid rowId:", rowId);
			}

			// Update the state with the modified data
			state.initialData = tempInitialData;
		},

		handleOnEditAddedDataReducer: (state, actions) => {
			const { name, id, value } = actions.payload;
			console.log({ editNow: name, value, id });
			const tempAddAddedData = [...state.addedData];
			tempAddAddedData[id][name] = value;
			// console.log(id, name);
			state.addedData = tempAddAddedData;
		},
		// old
		addAddedData: (state, actions) => {
			state.addedData.push(actions.payload);
		},
		addEditedData: (state, actions) => {
			state.editedData = actions.payload;
		},
		addOnEditCellData: (state, actions) => {
			state.onEditCellList = actions.payload;
		},
		clearData: (state) => {
			state.addedData = [];
			state.editedData = [];
			state.onEditCellList = [];
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getInitialData,
	getPartnerList,
	getPaymentModeList,
	handleOnEditPaymentModeReducer,
	handleOnEditAddedDataReducer,
	// Old
	addAddedData,
	addEditedData,
	addOnEditCellData,
	clearData,
} = paymentModeAndFeesSlice.actions;

export default paymentModeAndFeesSlice.reducer;
